/* eslint-disable sonarjs/no-hardcoded-passwords */
export const bma = {
    twoUpMarketName: '2Up - Instant Win',
    gotIt: 'GOT IT!',
    twoUp: '2up',
    joinUs: 'Join',
    joinNow: 'Join Now',
    signIn: 'Log In',
    signInBet: 'Log In & Place Bet',
    login: 'Login',
    videoStreamRegister: {
        part1: ' or ',
        part2: 'Register',
        part3: ' to watch live streams now',
    },
    myBets: 'My Bets',
    horceRacingBIR: 'BET IN PLAY',
    LOGIN_ERROR: 'Incorrect details. Please check and try again.',
    LOGIN_RETAIL_ERROR: 'Please use your username and password to log in',
    CHANGEPASSWORD_COMMON_ERROR: 'Authentication error',
    BLOCKED_ACCOUNT: 'Please contact Customer Support. We apologise for any inconvenience caused.',
    FROZEN_OR_DUBLICATE_ACCOUNT:
        'It appears you may already have an account with us. ' +
        "If you cannot remember your Username or Password, please click on 'Forgot Username?' or 'Forgot Password?' below or contact " +
        'Customer Support',
    FRAUDULENT: 'Please contact Customer Support. We apologise for any inconvenience caused.',
    INCORRECT_PASSWORD: 'Incorrect old password',
    PASSWORD_USED: 'Password has already been used recently.',
    UNKNOWN_PLAYER: 'Unknown player',
    INVALID_EMAIL: 'Not valid user email',
    INVALID_BIRTHDATE: 'Not valid birth date',
    TIMEOUT_ERR: 'Could not connect to the server. Please Try again.',
    NO_UNIQUE: 'No unique player was found.',
    contacts: 'Contact Us',
    help: 'Help',
    downloadCoralApps: 'Download Coral Apps',
    showBalance: 'Show Balance',
    hideBalance: 'Hide Balance',
    freeBetsDesc: 'BET TOKENS & FREE BETS',
    freeBets: 'Free Bets',
    validOn: 'valid on ',
    bingoBonus: 'Bingo bonus',
    casinoplayable: 'Casino Playable Balance',
    tokens: 'Tokens',
    token: 'Token',
    freeBetsTotal: 'Bet Tokens & Free Bets Total:',
    expires: 'Expires',
    ok: 'Ok',
    noFreeBets: 'You currently have no Free Bets',
    betNow: 'Bet Now',

    noData: 'No Data',
    noDataMsg: 'No data found',
    other: 'Other...',
    selectValue: 'Please select a limit',
    none: 'None',
    hour: '%1 Hour',
    hours: '%1 Hours',
    afterRegistrationOverlayTitle: 'Deposit Limit',
    afterRegistrationOverlayWelcomeUser: 'Welcome {username} to Coral',
    afterRegistrationOverlayErrorTitle: 'Error in case of setting Deposit Limits or Game Play Reminder',
    afterRegistrationOverlayErrorBody: 'You can set Deposit Limits and Game Play Reminder in My Account - Limits page.',
    IWouldLikeSetDepositLimits: 'I would like to Set Deposit Limits',
    LCCPdepositLimitsTitle: 'If you would like to set your deposit limits, please enter amount below',
    depositLimitsContext: 'If you would like to set your deposit limits, please enter amount below',
    setLimitsBtn: 'Set my deposit limits',
    confirmBtn: 'Confirm',
    closeBtn: 'Close',

    toCoral: 'New to Coral?',
    or: 'or',
    createUser: 'Join us here',
    resetPasswordLink: 'Reset Password?',
    forgotUsername: 'Forgot username?',
    forgotPassword: 'Forgot password?',
    forgotDetails: 'Forgot login details?',
    loginSuccess: 'Sign In successful',
    rememberMe: 'Remember me',
    rememberNameCard: 'Remember username or Connect Card number',
    rememberName: 'Remember username',
    deposit: 'Deposit',

    myAcc_DEPOSIT: 'DEPOSIT',
    myAcc_WITHDRAW: 'WITHDRAW',
    myAcc_ADDNEWPAYMENTTYPE: 'ADD NEW PAYMENT TYPE',
    myAcc_VOUCHERCODE: 'VOUCHER CODE',
    myAcc_BETHISTORY: 'BET HISTORY',
    myAcc_TRANSACTIONHISTORY: 'TRANSACTION HISTORY',
    myAcc_GAMINGHISTORY: 'GAMING HISTORY',
    myAcc_LIMITS: 'LIMITS',
    myAcc_CHANGEPASSWORD: 'CHANGE PASSWORD',
    myAcc_RESPONSIBLEGAMBLING: 'RESPONSIBLE GAMBLING',

    fallersInsurance: "Faller's Insurance",
    beatenByLength: 'Beaten by a Length',
    extraPlace: 'Extra Place',
    priceBoost: 'Odds Booster',
    moneyBack: 'Money Back',
    doubleWinnings: 'Double Your Winnings',
    yourCall: 'Your call',
    accaInsurance: 'Acca Insurance',
    luckyDip: 'Lucky Dip',

    contactUs: 'Contact Us',
    azSports: 'AZ Sports',
    cricket: 'Cricket',
    email: 'Email',
    emailAddress: 'Email Address',
    remindMe: 'Remind Me',
    gaming: 'Gaming',
    greyhounds: 'Greyhounds',
    inPlay: 'In-Play',
    liveStream: 'Live Stream',
    sports: 'Sports',
    game: 'Games',
    betslip: 'Betslip',
    userName: 'Username',
    resetPassword: 'Reset Password',
    forgotUsernameTitle: 'Forgot Username',
    responsibleGambling: 'Responsible Gambling Policy',
    snooker: 'Snooker',
    tennis: 'Tennis',
    signUpTitle: 'Registration',
    signUpStep: 'Step ',
    signUpTitleOf: ' of 2',
    mobileSignUpTitleOf: ' of 3',
    personalSection: 'Personal Section',
    personalDetails: 'Personal Details',
    socialStatus: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDate: 'Date of Birth',
    birthDateDay: 'Day',
    birthDateMonth: 'Month',
    birthDateYear: 'Year',
    good: 'Good News!',
    protectMsg:
        'We hold your money in am independent trust account to ensure that it is completely protected. ' +
        "This meets the UK Gambling Commission's requirement for the protection of customer funds at the high level of protection. " +
        'For more information you can visit the UK Gambling Commission ' +
        "<a href='http://www.gamblingcommission.gov.uk/Consumers/Protection-of-customer-funds.aspx' target='_blank'>here.</a>",
    continue: 'Continue',

    passwordChangeDialogueHeader: 'Change Password',
    passwordChangeDialogueMessage: 'Use the form below to change your password',
    passwordChangeChangeButton: 'Change Password',
    passwordChangeNewPasswordVerify: 'Confirm New Password',
    tempPassword: 'Temporary Password',
    typePassword: 'Type Password',
    oldPassword: 'Old Password',
    passwordChangeUserNewPassword: 'New Password',

    termsAndConditionsViewTerms: 'View Terms',
    termsAndConditionsTacTeaser:
        'Our Terms and Conditions have changed to reflect the fact that our services to customers ' +
        'in the UK are now offered under a Licence issued by the UK Gambling Commission. The revised terms and conditions are below. ' +
        'Please acknowledge this change by clicking OK',
    termsAndConditionsDialogueHeader: 'Terms &amp; Conditions',
    termsAndConditionsOk: 'OK',

    error: 'Error',
    errorOccurred: 'An error has occurred, Please try again later or contact Customer Support.',
    apologies: 'Apologies',
    bannedCountry: 'Unfortunately Coral is not yet available in your country.',
    invalidPassword: 'Your password is invalid. Please try again',
    vipLevelsNames: {
        11: 'BRONZE',
        12: 'SILVER',
        13: 'GOLD',
        14: 'PLATINUM',
    },

    myAccount: 'My Account',
    loggedTime: 'Logged in time:',
    cashBalance: 'Cash Balance',
    wBack: 'Welcome back',
    openBets: 'Open Bets',
    logOut: 'Log Out',

    cancel: 'Cancel',
    findBtn: 'Find',
    nextStep: 'Go to Step 2',
    nextStepMobile: 'Next Step',
    submit: 'Complete Registration',
    prevStep: 'Step 1',
    viewFullRace: 'View Full Race Card',

    termsAndConditionsLabel: 'Terms &amp; Conditions',
    termsAndConditionsText:
        'I confirm that I am at least 18 years of age and that I accept the %1 (incorporating the Privacy Policy) ' +
        'and Age Verification Policy as published on this site.',
    termsAndConditionsOnStep1And2:
        'In order to complete registration, you will be required to confirm that you are at least 18 years ' +
        'of age and that you accept the %1 (incorporating the Privacy Policy) and Age Verification Policy as published on this site.',

    loginName: 'Username',
    loginNameCard: 'Enter your Coral online username or your Connect Cаrd numbеr',
    loginPassword: 'Password',
    loginPasswordPin: 'Password or 4-digit pin',
    address: 'Address',
    country: 'Country of Residence',
    postcode: 'Postcode',
    postcodeUk: 'UK Postcode',
    ukPostCodeError: 'There are no any addresses by entered postcode',
    manualAddress: 'Please %1 to enter your address manually',
    clickHere: 'click here',
    address1: 'Address line 1',
    address2: 'Address line 2',
    address3: 'Address line 3',
    city: 'City/Town',
    contactDetails: 'Сontact Details',
    mobile: 'Mobile Number',
    emailVerification: 'Confirm Email',
    usernamePassword: 'Username/Password',
    userPassword: 'Password',
    passwordVerify: 'Confirm Password',
    currency: 'Currency',
    depositLimit: 'Deposit Limit',
    marketingMessages: 'Marketing Messages',
    marketingMessagesText: 'I would like to receive free bets and exciting offers from Coral.co.uk',
    enterAddressManually: 'Enter address manually',
    accountDetails: 'Account Details',

    success: 'Success',
    successMessage: 'You was registered successful! Please check your e-mail.',
    usernameSuccessMessage: 'Your Username has been sent to your registered email address. Please remember to check your Spam/Junk folder.',
    resetPasswordSuccessMessage:
        'A new password has been sent to your registered email address. ' + 'Please remember to check your Spam/Junk folder.',
    passwordChangeSuccess: 'Your password has been changed successfully.',

    loggedOutByServerTitle: 'Logged Out',
    loggedOutByServerMessage: 'You have been logged out.',

    errorMessage: 'An internal error occurred within the back end system. Contact Coral for more information.',
    loginToSeeCashoutMessage: 'Please log in to see your Cash Out bets.',
    errorServiceDepartmentMessage: 'If this problem persists, contact our ',
    errorServiceDepartmentLink: 'Customer Service Department',
    serverError: 'Server is unavailable at the moment, please try again later.',

    signupTooltipInfo: 'Information',
    signupTooltipDepositLimit: 'Deposit limits must be positive, larger than £0.01, have a maximum of two decimals and maximum 7 digits.',

    validatorTooltipsEqualToEmailVerification:
        'The email address entered is different from the one above or previous entry is not valid, ' + 'please correct this.',
    validatorTooltipsEqualToPasswordVerify: 'Sorry, password does not match the previous entry or previous entry is not valid, please retry.',
    validatorTooltipsNotEqualUserPassword: 'Your new password should not be same as old one.',

    validatorTooltipsDepositLimitsDaily: 'The Daily limit must be lower than the weekly and monthly limit.',
    validatorTooltipsDepositLimitsWeekly: 'The Weekly limit must be higher than the daily limit and lower than the monthly limit.',
    validatorTooltipsDepositLimitsMonthly: 'The Monthly limit must be higher than the daily limit and higher than the weekly limit.',
    validatorTooltipsDepositLimitsDepositLimit: 'Sorry, invalid character used or too high value (must be 0-99,000).',
    validatorTooltipsDepositLimitsMinDepositLimit: 'Please enter an amount greater than ',

    validatorTooltipsDateFormatInvalidEntry: 'Invalid entry, please provide an accurate date of birth.',
    validatorTooltipsDateFormatNoEntry: 'Please provide your date of birth.',
    validatorTooltipsAdultAge: 'You must be over 18 years old to create an account.',
    validatorTooltipsEmail: 'Please enter a valid email address.',
    validatorTooltipsUsernameUnavailable:
        'Username you entered is already in use. Please enter a different username, ' + 'or select one of the following proposed.',
    validatorTooltipsOther: 'Other...',
    emailAlreadyExistsMessage:
        'It appears you may already have an account with us. If you cannot remember your Username or Password, ' +
        "please click on 'Forgot Username?' or 'Forgot Password?' below",

    validatorTooltipsRequiredUserPassword: 'Please enter your password.',
    validatorTooltipsRequiredPasswordVerify: 'Please enter your password again.',
    validatorTooltipsRegexpUserName:
        'Sorry, invalid username is entered (must be 6-32 characters long, using A-Z, a-z, 0-9, -, _). ' + 'Please try again.',
    validatorTooltipsRegexpUserPassword:
        'Sorry, invalid password is entered (must be 6-10 characters long, ' + 'using A-Z, a-z, 0-9, - ! ^ * ( ) _ + ). Please try again.',
    validatorTooltipsRegexpPasswordVerify:
        'Sorry, invalid password is entered (must be 6-10 characters long, ' + 'using A-Z, a-z, 0-9, - ! ^ * ( ) _ + ). Please try again.',
    validatorTooltipsRequiredEmail: 'Please enter email address.',
    validatorTooltipsRequiredUserName: 'Please enter your username.',

    userSettingsHeading: 'Preferences',
    userSettingsOddsFormatLabel: 'Select Odds Format',
    userSettingsOddsFormatFrac: 'Fractional',
    userSettingsOddsFormatDec: 'Decimal',
    userSettingsTouchIdLogin: 'Touch/Face ID Login',
    userSettingsFingerprintLogin: 'Fingerprint login',
    userSettingsTouchIdLoginEnabled: 'Enabled',
    userSettingsTouchIdLoginDisabled: 'Disabled',
    userSettingsDiagnostics: 'Diagnostics',
    userSettingsSendReport: 'Send report',
    userSettingsQuickBet: 'Allow Quick Bet',
    userSettingsTimeline: 'Coral Pulse',
    userSettingsTimelineDescription: 'Display Coral Pulse when I login.',

    freebetsExpiryMessage: 'You have a free bet which is due to expire in',
    freebetsAvailableMessage: 'You have a free bet(s) available. Tap on the stake box to use it',
    freebetsExpiryHours: 'hours',
    freebetsExpiryMins: 'mins',
    freeBet: 'Free Bet',
    betToken: 'Bet Token',
    fanZone: 'Fanzone',
    fanZoneFreebet: 'Fanzone Free bet',
    freeBetTitle: 'MY FREE BETS',
    freebetDetails: 'Freebet Information',
    noFreeBetsFound: 'No Freebets available',
    cashBalanceFreeBet: 'Cash Balance: ',
    goBetting: 'Go Betting',
    totalBalance: 'Total: ',
    freeBetsAvailable: 'Free Bet Available',
    freeBetsName: 'Free Bets',
    freeBetName: 'FreeBet',
    addFreeBet: 'Add',
    apply: 'APPLY',
    more: 'MORE',
    useBy: 'use by ',
    useNow: 'USE NOW',
    avilableBetTokens: 'Available Bet Tokens',
    expiresFreeBets: 'Expires: ',

    sessionTimeLimit: 'Session Time Limit',
    hi: 'Hi',
    aboutToExpireWarnMessage:
        ', The session limit you selected will take effect in 5 minutes. ' + 'Please note that you will be logged out at that time.',
    hourlyNotification: 'Hourly Notification',
    hourlyNotificationMessage: 'This is your hourly notification.',

    today: 'Today',
    tomorrow: 'Tomorrow',
    moreInformation: 'More information',
    moreInfo: 'More Info',
    accept: 'Accept & close',

    depositNotificationHi: 'Hi ',
    depositNotificationTitle: 'Quick Deposit',
    depositNotification1: 'You currently have ',
    depositNotification2: ' in your account.',
    depositNotificationBtn: 'Deposit Now',
    depositLimitsTitle: 'You Have A Pending Deposit Limit Increase',

    depositNotificationLimitDecline: 'Decline',

    depositNotificationLimit1: 'Click ',
    depositNotificationLimitConfirm: 'Confirm ',
    depositNotificationLimit3: 'to confirm the new deposit limits:',
    depositNotificationLimit4: 'Clicking on ',
    depositNotificationLimitCancel: 'Cancel ',
    depositNotificationLimit5: 'will void the pending limits.',

    depositDaily: 'Daily',
    depositWeekly: 'Weekly',
    depositMonthly: 'Monthly',

    verificationBtn: 'Verify Me Now!',
    verificationTitle: 'Verify Your Account',
    verificationBodyPart1: 'We just need a few details',
    verificationBodyPart2: 'Due to our licensing commitments and for the safety of all our customers we are required to',
    verificationBodyPart2a: 'verify all players',
    verificationBodyPart2b: 'on our system.',
    verificationBodyPart3: 'Unfortunately we have not been able to verify your details',
    verificationBodyPart3a: ' and therefore your account has been temporarily suspended',
    verificationBodyPart4:
        'Using your device you can quickly and safely upload a photo of your driving lisence or ID document(s) ' +
        'through our secure service so that we can',
    verificationBodyPart4a: 'complete your verification',
    verificationBodyPart4b: ' and reactivate your account',
    verificationBodyPart5: 'This will prevent your account from being disabled.',

    selfExclusion: 'Self Exclusion',
    setDeposit: 'SET DEPOSIT LIMITS',
    selfExclusionInfo:
        'Self-exclusion is a formal process whereby you request us to prevent you from being able to access ' +
        "your online account for a specified period between 12 months and 5 years. Under such an agreement, we will 'close' " +
        'any accounts you hold with us.',
    selfExclusionUriText: 'READ MORE ABOUT SELF EXCLUSION',
    selfExclusionFormUri: 'REQUEST A SELF EXCLUSION FORM',
    selfExcludeForm: 'Request Self-Exclusion',
    selfExclusionTitle: 'More About Self Exclusion',
    selfExclusionBtn: 'Click here',
    selfExclusionConfirm: 'to confirm that you wish to Self-Exclude.',
    selfExclusionSelectHeader: 'Please select how long you would like to Self-Exclude for:',
    selfExclusionInputHeader: 'In order to complete Self-Exclusion, please provide your password:',
    choosePeriod: 'Choose Self Exclusion Period',
    coral: 'Coral',
    galaCoralInteractive: 'Gala Coral Interactive',
    download: 'Download',
    messageMaintenance: 'Oops! Apologies, something went wrong. Click below to reload the page.',
    refresh: 'Reload',
    retry: 'Retry',
    callToAction: 'Call To Action',
    noLogin: 'You must log in to view this page.',
    noPromo: 'Promotion is expired or unavailable',

    loggedOut: 'You Are Logged Out',
    loggedOutTittle: 'Sorry your session appears to have expired. Please login again.',
    loggedOutTittleSessionLimit: 'Your session has expired. Your current session time limit is set at %1 minutes. Please login again.',

    mobengaUpgradeDialogTitle: 'Application Upgrade',
    copy: 'Copy',
    copied: 'Copied',
    notCopied: 'Not copied',
    needHelp: 'Need help?',

    internetError: 'No internet connection',
    connectionLostMessage:
        'You are currently experiencing issues connecting to the internet. ' + 'Please check your internet connection and try again.',
    asyncOpeningMessage: 'Please wait while you are being redirected...',

    v2header: {
        balance: 'Balance',
        quickDeposit: 'Quick Deposit',
        betSlip: 'Bet Slip',
        account: 'Account',
    },

    acceptBonus: 'ACCEPT',
    declineBonus: 'DECLINE',
    bonusTitle: 'Congratulations!',
    no: 'No',
    bonusMessage: 'Hi {name}, {msg}',
    acceptBtn: 'Accept',
    declineBtn: 'Decline',

    functionalityDisabled: 'This functionality is disabled.',
    showPassword: 'Show',
    hidePassword: 'Hide',
    back: 'Back',

    callFromUk: 'Call from UK',
    callNotFromUk: 'Call from outside UK',
    marketingPreferences: 'Marketing Preferences',
    offeringUpdateTypesCaption:
        'We don’t want you to miss out on our latest prices, live betting updates and free bet offers. ' +
        'By ticking the boxes below, you’ll be kept informed of all our offerings. Your selections will automatically be saved.',
    groupOfBrandsCaption:
        'Coral is a brand within the Ladbrokes Coral Group. Our group of brands offer online and offline sports betting, ' +
        'casino, bingo and gaming services. If you would like to receive information and promotional offers from any of the other ' +
        'brands within our Group, please select below: ',
    all: 'All',
    submitBtn: 'Submit',
    regOfferingTypesCaption: 'Receive communication via:',
    savePreferencesBtn: 'Save my preferences',
    brands: {
        ladbrokes: 'Ladbrokes',
        bingo: 'Gala Bingo',
        casino: 'Gala Casino',
        spins: 'Gala Spins',
    },
    optInSplash: {
        optInButton: 'Opt In',
        skipButton: 'No Thanks',
        footerNote: 'Update your settings at any time in Account Preferences.',
    },
    preferencesError: "Sorry, we couldn't save your selected preferences. Please try again.",
    hide: 'Hide',
    show: 'Show',

    yes: 'Yes',
    gamePlayReminder: ' Game play Reminder',
    depositLimitLink: 'Deposit Limit ',
    important: 'Important',
    byb: 'Bet Builder',
    betBuilder: 'BET BUILDER',

    countryRestriction: {
        header: 'Country Restriction',
        racingMessageBody: 'We are unable to offer Horse Racing or Greyhound betting in your jurisdiction.',
        lottoMessageBody: 'We are unable to offer Lotto betting in your jurisdiction',
        jackpotMessageBody: 'We are unable to offer Football Jackpot betting in your jurisdiction',
    },

    otf: {
        btnProcessing: 'Processing...',
        bundleLoading: 'Loading...',
        cancelLogin: 'Cancel',
        loginToPlay: 'Login to play',
        upgradeAndPlay: 'Upgrade and Play',
        noContent: 'No content provided',
        playNow: 'Play Now',
        bundleLoadingErrorMsg: 'Sorry, we are having some technical issues. Please try again soon.',
        bundleLoadingErrorBtn: 'GO BACK',
    },
    otfPageTitle: '1-2-Free',
    miniGamesError: 'Mini Games currently unavailable, please try again later.',
    filters: {
        competitionPage: 'Starting In:',
        landingPage: '',
    },
    okThanks: 'OK, THANKS',
    drawresults: 'Draw results',
    returned: ' Returned',
};
